import styles from '../player.module.scss';
import __isEmpty from 'lodash/isEmpty';
import CodiEspectador from '../../CodiEspectador';

export default function InfoVideo(props) {
    const { edat } = props;
    const codiEdat = edat?.replace('CE_', '').replace(/^0+/, '');
    const altEdat = codiEdat && !isNaN(codiEdat) ? `${codiEdat} anys` : '';
    return (
        <div className={styles.infoVideoWrapper}>
            <div className={styles.subinfo}>
                {edat !== 'CE_TP' && !__isEmpty(edat) && (
                    <span className={styles.edat}>
                        <CodiEspectador codi={edat} alt={altEdat} mida='24' />
                    </span>
                )}
            </div>
        </div>
    );
}
